import { c as _c } from "react/compiler-runtime";
// Карточка рекламной кампании в консоли (этап 8, П1: fd-promo-29, fd-promo-30).
//
// Модератор видит всё, что проверяет: товары (опубликованы ли), описание и
// баннер, модель и ставку, бюджет, период и таргетинг, срок модерации.
// Одобрить или отклонить — только с правом «Модерация рекламы»; отказ без
// причины невозможен, продавец получает уведомление с причиной. Ниже —
// показатели кампании за 30 дней.
import { ArrowLeft, Check, Loader2, X } from "lucide-react";
import { useState } from "react";
import { Link, useParams } from "react-router";
import { hasAdminPermission } from "@/lib/admin-permissions";
import { cn } from "@/lib/utils";
import { useAuth } from "@/store";
import { Button } from "@osmix/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@osmix/ui/dialog";
import { dateOnly, dateTime, lastDays, modelLabel, pct, rateLabel, rub, slaLabel, useAdminCampaign, useAdminCampaignStats, useAdModeration } from "./ad-campaigns-api";
import { StatusBadge } from "./ad-campaigns";
export function AdCampaignDetailPage() {
  const $ = _c(191);
  const {
    id: t0
  } = useParams();
  const id = t0 === undefined ? "" : t0;
  const t1 = useAuth(_temp);
  let t2;
  if ($[0] !== t1) {
    t2 = hasAdminPermission(t1, "action.ads.moderate");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const canModerate = t2;
  const {
    data: c,
    isLoading,
    error
  } = useAdminCampaign(id);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = lastDays(30);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const range = t3;
  const stats = useAdminCampaignStats(id, range);
  const {
    approve,
    reject
  } = useAdModeration();
  const [rejecting, setRejecting] = useState(false);
  const [reason, setReason] = useState("");
  const [actionError, setActionError] = useState(null);
  if (isLoading) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Loader2 className="size-5 animate-spin" />;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  if (error || !c) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <p className="text-sm text-destructive">Кампания не найдена.</p>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  const pending = c.status === "pending_moderation";
  let t4;
  if ($[5] !== c.slaDueAt) {
    t4 = slaLabel(c.slaDueAt);
    $[5] = c.slaDueAt;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const sla = t4;
  const totals = stats.data?.totals;
  let t5;
  if ($[7] !== approve || $[8] !== c.id) {
    t5 = async () => {
      setActionError(null);
      ;
      try {
        await approve.mutateAsync(c.id);
      } catch (t6) {
        const e = t6;
        setActionError((e as Error).message);
      }
    };
    $[7] = approve;
    $[8] = c.id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const doApprove = t5;
  let t6;
  if ($[10] !== c.id || $[11] !== reason || $[12] !== reject) {
    t6 = async () => {
      setActionError(null);
      ;
      try {
        await reject.mutateAsync({
          id: c.id,
          reason: reason.trim()
        });
        setRejecting(false);
        setReason("");
      } catch (t7) {
        const e_0 = t7;
        setActionError((e_0 as Error).message);
      }
    };
    $[10] = c.id;
    $[11] = reason;
    $[12] = reject;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const doReject = t6;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link to="/ad-campaigns" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="size-4" />Реклама</Link>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== c.title) {
    t8 = <span className="break-words">{c.title}</span>;
    $[15] = c.title;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== c.status) {
    t9 = <StatusBadge status={c.status} />;
    $[17] = c.status;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <h1 className="flex flex-wrap items-center gap-3 text-xl font-semibold">{t8}{t9}</h1>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = c.shopName ?? c.shopId;
  let t12;
  if ($[22] !== c) {
    t12 = modelLabel(c);
    $[22] = c;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== c) {
    t13 = rateLabel(c);
    $[24] = c;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t14 = <p className="mt-1 text-sm text-muted-foreground">{t11} · {t12} · {t13}</p>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t10 || $[31] !== t14) {
    t15 = <div className="min-w-0">{t10}{t14}</div>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== approve || $[34] !== canModerate || $[35] !== doApprove || $[36] !== pending) {
    t16 = pending && canModerate && <div className="flex gap-2"><Button onClick={() => void doApprove()} disabled={approve.isPending} data-testid="ads-approve">{approve.isPending ? <Loader2 className="size-4 animate-spin" /> : <Check className="size-4" />}Одобрить</Button><Button variant="outline" onClick={() => setRejecting(true)} data-testid="ads-reject"><X className="size-4" />Отклонить</Button></div>;
    $[33] = approve;
    $[34] = canModerate;
    $[35] = doApprove;
    $[36] = pending;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <div className="flex flex-wrap items-start justify-between gap-4">{t15}{t16}</div>;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== c.slaDueAt || $[42] !== c.submittedAt || $[43] !== pending || $[44] !== sla) {
    t18 = pending && <p className={cn("rounded-lg border px-4 py-3 text-sm", sla.overdue ? "border-destructive/40 text-destructive" : "")}>Отправлена {dateTime(c.submittedAt)}. Решение до {dateTime(c.slaDueAt)} - {sla.text}.</p>;
    $[41] = c.slaDueAt;
    $[42] = c.submittedAt;
    $[43] = pending;
    $[44] = sla;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== c.rejectReason || $[47] !== c.status) {
    t19 = c.status === "rejected" && c.rejectReason && <p className="rounded-lg border border-destructive/40 px-4 py-3 text-sm text-destructive">Причина отказа: {c.rejectReason}</p>;
    $[46] = c.rejectReason;
    $[47] = c.status;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== actionError) {
    t20 = actionError && <p className="text-sm text-destructive">{actionError}</p>;
    $[49] = actionError;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <h2 className="font-medium">Условия</h2>;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== c) {
    t22 = modelLabel(c);
    $[52] = c;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== t22) {
    t23 = <Row label={"\u041C\u043E\u0434\u0435\u043B\u044C"}>{t22}</Row>;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== c) {
    t24 = rateLabel(c);
    $[56] = c;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t24) {
    t25 = <Row label={"\u0421\u0442\u0430\u0432\u043A\u0430"}>{t24}</Row>;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== c.spent) {
    t26 = rub(c.spent);
    $[60] = c.spent;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== c.budgetTotal) {
    t27 = rub(c.budgetTotal);
    $[62] = c.budgetTotal;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== c.budgetDaily) {
    t28 = c.budgetDaily != null && <span className="text-muted-foreground"> · в день до {rub(c.budgetDaily)}</span>;
    $[64] = c.budgetDaily;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t26 || $[67] !== t27 || $[68] !== t28) {
    t29 = <Row label={"\u0411\u044E\u0434\u0436\u0435\u0442"}>{t26} из {t27}{t28}</Row>;
    $[66] = t26;
    $[67] = t27;
    $[68] = t28;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== c.startsAt) {
    t30 = dateOnly(c.startsAt);
    $[70] = c.startsAt;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== c.endsAt) {
    t31 = dateOnly(c.endsAt);
    $[72] = c.endsAt;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t30 || $[75] !== t31) {
    t32 = <Row label={"\u041F\u0435\u0440\u0438\u043E\u0434"}>{t30} - {t31}</Row>;
    $[74] = t30;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  let t33;
  if ($[77] !== c.targeting.regionIds) {
    t33 = c.targeting.regionIds.length ? c.targeting.regionIds.join(", ") : "\u0432\u0441\u0435";
    $[77] = c.targeting.regionIds;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== t33) {
    t34 = <Row label={"\u0420\u0435\u0433\u0438\u043E\u043D\u044B"}>{t33}</Row>;
    $[79] = t33;
    $[80] = t34;
  } else {
    t34 = $[80];
  }
  let t35;
  if ($[81] !== c.targeting.categoryIds) {
    t35 = c.targeting.categoryIds.length ? c.targeting.categoryIds.join(", ") : "\u0432\u0441\u0435";
    $[81] = c.targeting.categoryIds;
    $[82] = t35;
  } else {
    t35 = $[82];
  }
  let t36;
  if ($[83] !== t35) {
    t36 = <Row label={"\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438"}>{t35}</Row>;
    $[83] = t35;
    $[84] = t36;
  } else {
    t36 = $[84];
  }
  let t37;
  if ($[85] !== c.moderatedAt) {
    t37 = c.moderatedAt && <Row label={"\u0420\u0435\u0448\u0435\u043D\u0438\u0435"}>{dateTime(c.moderatedAt)}</Row>;
    $[85] = c.moderatedAt;
    $[86] = t37;
  } else {
    t37 = $[86];
  }
  let t38;
  if ($[87] !== t23 || $[88] !== t25 || $[89] !== t29 || $[90] !== t32 || $[91] !== t34 || $[92] !== t36 || $[93] !== t37) {
    t38 = <section className="flex flex-col gap-3 rounded-lg border p-4">{t21}{t23}{t25}{t29}{t32}{t34}{t36}{t37}</section>;
    $[87] = t23;
    $[88] = t25;
    $[89] = t29;
    $[90] = t32;
    $[91] = t34;
    $[92] = t36;
    $[93] = t37;
    $[94] = t38;
  } else {
    t38 = $[94];
  }
  let t39;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <h2 className="font-medium">Описание</h2>;
    $[95] = t39;
  } else {
    t39 = $[95];
  }
  const t40 = c.description || "\u0411\u0435\u0437 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044F";
  let t41;
  if ($[96] !== t40) {
    t41 = <p className="text-sm whitespace-pre-line">{t40}</p>;
    $[96] = t40;
    $[97] = t41;
  } else {
    t41 = $[97];
  }
  let t42;
  if ($[98] !== c.bannerUrl) {
    t42 = c.bannerUrl && <img src={c.bannerUrl} alt={"\u0411\u0430\u043D\u043D\u0435\u0440 \u043A\u0430\u043C\u043F\u0430\u043D\u0438\u0438"} className="aspect-[16/9] w-full rounded-md object-cover" />;
    $[98] = c.bannerUrl;
    $[99] = t42;
  } else {
    t42 = $[99];
  }
  let t43;
  if ($[100] !== t41 || $[101] !== t42) {
    t43 = <section className="flex flex-col gap-3 rounded-lg border p-4">{t39}{t41}{t42}</section>;
    $[100] = t41;
    $[101] = t42;
    $[102] = t43;
  } else {
    t43 = $[102];
  }
  let t44;
  if ($[103] !== c.productIds.length) {
    t44 = <h2 className="font-medium">Товары · {c.productIds.length}</h2>;
    $[103] = c.productIds.length;
    $[104] = t44;
  } else {
    t44 = $[104];
  }
  let t45;
  if ($[105] !== c.products) {
    t45 = c.products ?? [];
    $[105] = c.products;
    $[106] = t45;
  } else {
    t45 = $[106];
  }
  let t46;
  if ($[107] !== t45) {
    t46 = t45.map(_temp2);
    $[107] = t45;
    $[108] = t46;
  } else {
    t46 = $[108];
  }
  let t47;
  if ($[109] !== t46) {
    t47 = <ul className="flex flex-col gap-2">{t46}</ul>;
    $[109] = t46;
    $[110] = t47;
  } else {
    t47 = $[110];
  }
  let t48;
  if ($[111] !== t44 || $[112] !== t47) {
    t48 = <section className="flex flex-col gap-3 rounded-lg border p-4">{t44}{t47}</section>;
    $[111] = t44;
    $[112] = t47;
    $[113] = t48;
  } else {
    t48 = $[113];
  }
  let t49;
  if ($[114] !== t38 || $[115] !== t43 || $[116] !== t48) {
    t49 = <div className="grid gap-4 lg:grid-cols-3">{t38}{t43}{t48}</div>;
    $[114] = t38;
    $[115] = t43;
    $[116] = t48;
    $[117] = t49;
  } else {
    t49 = $[117];
  }
  let t50;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <h2 className="font-medium">Показатели за 30 дней <span className="text-sm font-normal text-muted-foreground">({range.from} - {range.to})</span></h2>;
    $[118] = t50;
  } else {
    t50 = $[118];
  }
  const t51 = totals?.impressions ?? 0;
  let t52;
  if ($[119] !== t51) {
    t52 = t51.toLocaleString("ru-RU");
    $[119] = t51;
    $[120] = t52;
  } else {
    t52 = $[120];
  }
  let t53;
  if ($[121] !== t52) {
    t53 = ["\u041F\u043E\u043A\u0430\u0437\u044B", t52];
    $[121] = t52;
    $[122] = t53;
  } else {
    t53 = $[122];
  }
  const t54 = totals?.clicks ?? 0;
  let t55;
  if ($[123] !== t54) {
    t55 = t54.toLocaleString("ru-RU");
    $[123] = t54;
    $[124] = t55;
  } else {
    t55 = $[124];
  }
  let t56;
  if ($[125] !== t55) {
    t56 = ["\u041A\u043B\u0438\u043A\u0438", t55];
    $[125] = t55;
    $[126] = t56;
  } else {
    t56 = $[126];
  }
  const t57 = totals?.ctr ?? null;
  let t58;
  if ($[127] !== t57) {
    t58 = pct(t57, 2);
    $[127] = t57;
    $[128] = t58;
  } else {
    t58 = $[128];
  }
  let t59;
  if ($[129] !== t58) {
    t59 = ["CTR", t58];
    $[129] = t58;
    $[130] = t59;
  } else {
    t59 = $[130];
  }
  const t60 = String(totals?.conversions ?? 0);
  let t61;
  if ($[131] !== t60) {
    t61 = ["\u041A\u043E\u043D\u0432\u0435\u0440\u0441\u0438\u0438", t60];
    $[131] = t60;
    $[132] = t61;
  } else {
    t61 = $[132];
  }
  const t62 = totals?.revenue ?? 0;
  let t63;
  if ($[133] !== t62) {
    t63 = rub(t62);
    $[133] = t62;
    $[134] = t63;
  } else {
    t63 = $[134];
  }
  let t64;
  if ($[135] !== t63) {
    t64 = ["\u0412\u044B\u0440\u0443\u0447\u043A\u0430", t63];
    $[135] = t63;
    $[136] = t64;
  } else {
    t64 = $[136];
  }
  const t65 = totals?.spend ?? 0;
  let t66;
  if ($[137] !== t65) {
    t66 = rub(t65);
    $[137] = t65;
    $[138] = t66;
  } else {
    t66 = $[138];
  }
  let t67;
  if ($[139] !== t66) {
    t67 = ["\u0420\u0430\u0441\u0445\u043E\u0434", t66];
    $[139] = t66;
    $[140] = t67;
  } else {
    t67 = $[140];
  }
  const t68 = totals?.roi ?? null;
  let t69;
  if ($[141] !== t68) {
    t69 = pct(t68, 0);
    $[141] = t68;
    $[142] = t69;
  } else {
    t69 = $[142];
  }
  let t70;
  if ($[143] !== t69) {
    t70 = ["ROI", t69];
    $[143] = t69;
    $[144] = t70;
  } else {
    t70 = $[144];
  }
  let t71;
  if ($[145] !== t53 || $[146] !== t56 || $[147] !== t59 || $[148] !== t61 || $[149] !== t64 || $[150] !== t67 || $[151] !== t70) {
    t71 = [t53, t56, t59, t61, t64, t67, t70];
    $[145] = t53;
    $[146] = t56;
    $[147] = t59;
    $[148] = t61;
    $[149] = t64;
    $[150] = t67;
    $[151] = t70;
    $[152] = t71;
  } else {
    t71 = $[152];
  }
  const t72 = t71 as [string, string][];
  let t73;
  if ($[153] !== t72) {
    t73 = <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-7" data-testid="ads-detail-totals">{t72.map(_temp3)}</div>;
    $[153] = t72;
    $[154] = t73;
  } else {
    t73 = $[154];
  }
  const t74 = `/ad-campaigns?tab=attributions&campaignId=${c.id}`;
  let t75;
  if ($[155] !== t74) {
    t75 = <Link to={t74} className="text-sm text-primary hover:underline">Заказы, засчитанные кампании →</Link>;
    $[155] = t74;
    $[156] = t75;
  } else {
    t75 = $[156];
  }
  let t76;
  if ($[157] !== t73 || $[158] !== t75) {
    t76 = <section className="flex flex-col gap-3">{t50}{t73}{t75}</section>;
    $[157] = t73;
    $[158] = t75;
    $[159] = t76;
  } else {
    t76 = $[159];
  }
  let t77;
  if ($[160] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = open => !open && setRejecting(false);
    $[160] = t77;
  } else {
    t77 = $[160];
  }
  let t78;
  if ($[161] === Symbol.for("react.memo_cache_sentinel")) {
    t78 = <DialogHeader><DialogTitle>Отклонить кампанию</DialogTitle><DialogDescription>Продавец получит уведомление с этой причиной и сможет исправить кампанию.</DialogDescription></DialogHeader>;
    $[161] = t78;
  } else {
    t78 = $[161];
  }
  let t79;
  if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = e_1 => setReason(e_1.target.value);
    $[162] = t79;
  } else {
    t79 = $[162];
  }
  let t80;
  if ($[163] !== reason) {
    t80 = <textarea value={reason} onChange={t79} rows={4} maxLength={1000} placeholder={"\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u0444\u043E\u0442\u043E \u0442\u043E\u0432\u0430\u0440\u0430 \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044E"} className="w-full rounded-md border bg-background px-3 py-2 text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring" data-testid="ads-reject-reason" />;
    $[163] = reason;
    $[164] = t80;
  } else {
    t80 = $[164];
  }
  let t81;
  if ($[165] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = <Button variant="outline" onClick={() => setRejecting(false)}>Отмена</Button>;
    $[165] = t81;
  } else {
    t81 = $[165];
  }
  let t82;
  if ($[166] !== reason || $[167] !== reject.isPending) {
    t82 = reason.trim().length < 3 || reject.isPending;
    $[166] = reason;
    $[167] = reject.isPending;
    $[168] = t82;
  } else {
    t82 = $[168];
  }
  let t83;
  if ($[169] !== doReject) {
    t83 = () => void doReject();
    $[169] = doReject;
    $[170] = t83;
  } else {
    t83 = $[170];
  }
  let t84;
  if ($[171] !== reject.isPending) {
    t84 = reject.isPending && <Loader2 className="size-4 animate-spin" />;
    $[171] = reject.isPending;
    $[172] = t84;
  } else {
    t84 = $[172];
  }
  let t85;
  if ($[173] !== t82 || $[174] !== t83 || $[175] !== t84) {
    t85 = <DialogFooter>{t81}<Button variant="destructive" disabled={t82} onClick={t83} data-testid="ads-reject-confirm">{t84}Отклонить</Button></DialogFooter>;
    $[173] = t82;
    $[174] = t83;
    $[175] = t84;
    $[176] = t85;
  } else {
    t85 = $[176];
  }
  let t86;
  if ($[177] !== t80 || $[178] !== t85) {
    t86 = <DialogContent>{t78}{t80}{t85}</DialogContent>;
    $[177] = t80;
    $[178] = t85;
    $[179] = t86;
  } else {
    t86 = $[179];
  }
  let t87;
  if ($[180] !== rejecting || $[181] !== t86) {
    t87 = <Dialog open={rejecting} onOpenChange={t77}>{t86}</Dialog>;
    $[180] = rejecting;
    $[181] = t86;
    $[182] = t87;
  } else {
    t87 = $[182];
  }
  let t88;
  if ($[183] !== t17 || $[184] !== t18 || $[185] !== t19 || $[186] !== t20 || $[187] !== t49 || $[188] !== t76 || $[189] !== t87) {
    t88 = <div className="flex flex-col gap-6">{t7}{t17}{t18}{t19}{t20}{t49}{t76}{t87}</div>;
    $[183] = t17;
    $[184] = t18;
    $[185] = t19;
    $[186] = t20;
    $[187] = t49;
    $[188] = t76;
    $[189] = t87;
    $[190] = t88;
  } else {
    t88 = $[190];
  }
  return t88;
}
function _temp3(t0) {
  const [label, value] = t0;
  return <div key={label} className="rounded-lg border p-3"><div className="text-xs text-muted-foreground">{label}</div><div className="mt-1 font-semibold tabular-nums">{value}</div></div>;
}
function _temp2(p) {
  return <li key={p.id} className="flex items-center gap-3"><span className="size-10 shrink-0 overflow-hidden rounded bg-muted">{p.photo && <img src={p.photo} alt="" className="size-full object-cover" />}</span><span className="min-w-0 flex-1"><Link to={`/products/${p.id}`} className="block truncate text-sm hover:underline">{p.name}</Link><span className={cn("text-xs", p.status === "published" ? "text-muted-foreground" : "font-medium text-destructive")}>{p.status === "published" ? `${rub(p.price)} · опубликован` : "\u043D\u0435 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D"}</span></span></li>;
}
function _temp(s) {
  return s.user;
}
function Row(t0) {
  const $ = _c(7);
  const {
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-xs text-muted-foreground">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <span className="text-sm">{children}</span>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-0.5">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}